/** @format */

import React, { useState } from 'react';
import {
  Grid,
  IconButton,
  Button,
  Typography,
  TextField,
  CardActions,
  Card,
  CardContent,
  Tooltip,
  CircularProgress,
} from '@mui/material';
import { animateScroll as scroll } from 'react-scroll';
import createToast from 'components/Toast/Toast';
import {
  ConfirmDialog,
  SimpleDialog,
  ButtonLoading,
  Icons,
  TableItemActionsNew,
  PriceLabel,
} from 'components';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { getDynamicObjectAction } from 'utility';
import { makeStyles } from '@mui/styles';
import { numberWithCommas } from 'utility';
import {
  deleteGuild,
  aliasNameAccount,
  getCarTableList,
} from '../../../../../services/DetailAccountsServices';
import { AutoSettlementCMP } from './AutoSettlement';
import BusinessGrantPermission from './BusinessGrantPermission';

export default function NewGuildItem({
  data,
  dataGuild, // TODO: it's not suitable to pass all the data
  setIsDisableAll,
  blockedAccount = null,
  currencyText,
  refreshList = () => {},
  // itemKey
}) {
  // --STATES--//
  const [isLoading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isAutoSettleOpen, setIsAutoSettleOpen] = useState(false);
  const [isBusinessGrantPermissionOpen, setIsBusinessGrantPermissionOpen] = useState(false);
  const [alias, setAlias] = useState('');
  const [item, setItem] = useState('');
  const [deleting, setDeleting] = useState(false);
  const [isLoadingWithraw, setIsLoadingWithraw] = useState(false);

  // --HOOKS--//
  const classes = useStyles();
  const navigate = useNavigate();
  const handleSubmit = async () => {
    if (alias.trim() === '') {
      // دیالوگ ویرایش نام کسب و کار - نام حتما باید وارد شود
      return createToast('خطا', 'لطفا نام حساب کسب‌وکار مورد نظر خود را وارد نمایید.', 'danger');
    }
    setIsLoading(true);
    try {
      const dataParam = { aliasName: alias };
      await aliasNameAccount(dataParam, item.guildSrv.code);
      createToast('موفق', 'ویرایش حساب با موفقیت انجام شد.', 'success');
      setOpenDialog(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const actionsList = getDynamicObjectAction([
    'transferGuildBtn',
    'withdrawGuildBtn',
    'reportGuildBtn',
    'requestsSettlementGuildBtn',
    'settlementGuildBtn',
    'updateNameGuildBtn',
    'permissionsReceiveGuildBtn',
    'permissionsGrantedGuildBtn',
    'invoiceGuildBtn',
  ]);
  const delGuild = async (code) => {
    try {
      setDeleting(true);
      await deleteGuild(code);
      createToast('موفق', 'عملیات حذف با موفقیت انجام شد', 'success');
      refreshList();
    } catch (err) {
    } finally {
      setDeleting(false);
    }
  };
  // -- LOCAL VARIABLES --//

  const handleDialog = (item) => {
    setOpenDialog(true);
    setItem(item);
    const itemName = item.hasOwnProperty('aliasName') ? item.aliasName : item.guildSrv?.name;
    setAlias(itemName);
  };

  const handleChangeInput = (e) => {
    setAlias(e.target.value);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const AutoSettlement = (id, title, item) => {
    switch (title) {
      case 'settlement':
        navigate(`/Guilds/AutoSettlement/${id}?origin=financial`, {
          item,
        });
        break;
      case 'MoneyTransfer':
        navigate(`/TransferCreditGuild/${id}`);
        break;
      case 'Withdrawal':
        navigate(`/GuildCashout/${id}`, {
          item,
        });
        break;
      default:
        return;
    }
    scroll.scrollToTop();
  };

  const getStatusCartable = (id, title, item) => {
    setIsLoadingWithraw(true);
    setIsDisableAll(true);
    const data = {
      guildCode: item?.guildSrv?.code,
      typeCode: 'MULTI_CONFIRMATION_TYPE_SETTLEMENT',
      offset: '0',
      size: '10',
    };
    getCarTableList(data)
      .then((res) => {
        if (window.location.pathname != '/Guilds') {
          return;
        }
        if (
          res?.result?.length > 0 &&
          res?.result[0]?.multiConfirmationSrv?.enable &&
          !res?.result[0]?.multiConfirmationSrv?.left
        ) {
          navigate(
            `/GuildCartableCashOut/${id}?wCode=null&gCode=${
              item?.guildSrv?.code
            }&typeCode=MULTI_CONFIRMATION_TYPE_SETTLEMENT&cartableId=${
              res?.result[0]?.multiConfirmationSrv?.id || 'null'
            }`,
          );
        } else {
          navigate(`/GuildCashout/${id}`, {
            item,
          });
        }
      })
      .catch((error) => {})
      .finally((e) => {
        setIsLoadingWithraw(false);
        setIsDisableAll(false);
      });
  };

  const redirectToInvoice = (name) => {
    if (name) {
      scroll.scrollToTop();
      navigate({
        pathname: '/Invoice',
        search: `?guild=${name}`,
      });
    }
  };

  const redirectToSettlements = (guildId) => {
    if (guildId) {
      navigate({
        pathname: '/SettlementGuild',
        search: `?guildId=${guildId}&fromGuild=true`,
      });
    } else {
      createToast('خطا', 'شناسه حساب یافت نشد!', 'danger');
    }
  };

  const redirectToGrantPermision = (guildCode, type) => {
    if (guildCode && type === 'awarded') {
      navigate({
        pathname: '/Permission/GrantedGuild',
        search: `?guildCode=${guildCode}`,
      });
    } else if (guildCode && type === 'received') {
      navigate({
        pathname: '/Permission/ReceivedGuild',
        search: `?guildCode=${guildCode}`,
      });
    } else {
      createToast('خطا', 'کد یافت نشد!', 'danger');
    }
  };

  const redirectToTransactions = (name, accountId) => {
    if (name) {
      scroll.scrollToTop();
      navigate(`/TransactionsGuild/${accountId}`);
    }
  };

  const hasNoTransaction = !data?.hasTransaction || blockedAccount?.block; // TODO: It should be !data?.hasTransaction

  return (
    <Card
      xs={12}
      className={clsx(classes.root, {
        disabled: hasNoTransaction,
      })}
    >
      <CardContent
        className={clsx(classes.content, {
          disabled: hasNoTransaction,
        })}
      >
        {blockedAccount?.block ? (
          <Grid item className={classes.expiredFlag}>
            حساب مسدود شده
          </Grid>
        ) : null}
        {/* Titles */}
        <Grid
          container
          justifyContent="space-between"
          alignItems="flex-start"
          className={classes.cardHeader}
        >
          <Grid item className={classes.titlePart}>
            <Typography variant="h5" className={classes.titleText}>
              {data.hasOwnProperty('aliasName') ? data.aliasName : data.guildSrv?.name}
              {hasNoTransaction ? (
                <Tooltip
                  title="این حساب تفصیلی دارای تراکنش نمی‌باشد. با اولین تراکنش مالی شما در این صنف، حساب آن ایجاد خواهد شد و امکان حذف آن دیگر وجود نخواهد داشت."
                  className={classes.clickable}
                >
                  <span className={classes.infoIcon}>
                    <Icons icon="Info" color="#667585" hover="#667585" size="20" />
                  </span>
                </Tooltip>
              ) : null}
            </Typography>
            <Typography variant="h6" className={classes.subtitleText}>
              {data.guildSrv?.code ?? ''}
            </Typography>
          </Grid>
          <Grid item className={classes.titleActions}>
            {!blockedAccount?.block ? (
              !hasNoTransaction ? (
                actionsList['updateNameGuildBtn'] && (
                  <IconButton
                    className={classes.actionsIcon}
                    onClick={() => {
                      handleDialog(data);
                    }}
                    size="large">
                    <Icons icon="Edit" color="#000" size="20" />
                  </IconButton>
                )
              ) : (
                <IconButton
                  className={classes.actionsIcon}
                  onClick={() => delGuild(data?.guildSrv?.code)}
                  size="large">
                  {deleting ? (
                    <CircularProgress size={24} className={classes.buttonProgress} />
                  ) : (
                    <Icons icon="Trash" color="#667585" hover="#D92D20" size="20" />
                  )}
                </IconButton>
              )
            ) : null}
          </Grid>
        </Grid>

        <div className={classes.cardInside}>
          {/* Status */}
          <Grid
            item
            container
            alignItems="center"
            className={clsx(classes.propertyContainer, {
              disabled: hasNoTransaction,
            })}
            onClick={() => {
              if (hasNoTransaction) return;
              setIsAutoSettleOpen(true);
            }}
          >
            <span
              style={{
                opacity: data.isAutoSettle && !hasNoTransaction ? '1' : '0.5',
                height: '24px',
              }}
              className={classes.propertyIcon}
            >
              <Icons icon="Accept" color="#4CAF50" size="23" />
            </span>

            <Typography className={classes.property}>
              تسویه خودکار
              {data.isAutoSettle && !hasNoTransaction ? ' (فعال) ' : ' (غیرفعال) '}
            </Typography>
          </Grid>

          {/* Balances */}
          <Grid container justifyContent="space-between">
            <Grid item xs={12} md={6}>
              <Typography className={classes.balanceTitle}>موجودی :  </Typography>
              <Typography className={classes.balanceMoney}>
                <PriceLabel amount={data.amount} />
                <span className={classes.currencyText}>{currencyText}</span>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography className={classes.balanceTitle}>قابل برداشت : </Typography>
              <Typography className={classes.balanceMoney}>
                <PriceLabel amount={data.withdrawableAmount} />
                <span className={classes.currencyText}>{currencyText}</span>
              </Typography>
            </Grid>
          </Grid>

          <Typography className={classes.blockedAmount}>
            {/* <BlockIcon className={classes.blockedAmountIcon} /> */}
            مبلغ مسدود شده : 
            <b>
              {` ${blockedAccount?.amount ? numberWithCommas(blockedAccount?.amount) : 0}`}{' '}
              {currencyText}
            </b>
          </Typography>
        </div>
      </CardContent>
      <CardActions className={classes.actionButtons}>
        <Grid container>
          {actionsList['withdrawGuildBtn'] && (
            <ButtonLoading
              onClick={() => getStatusCartable(data.id, 'Withdrawal', data)}
              size="small"
              disabled={hasNoTransaction || isLoadingWithraw}
              className={classes.actionButton}
              loading={isLoadingWithraw}
              name="برداشت وجه"
            />
          )}
          {actionsList['transferGuildBtn'] && (
            <Button
              onClick={() => AutoSettlement(data.id, 'MoneyTransfer', data)}
              size="small"
              disabled={hasNoTransaction}
              className={classes.actionButton}
            >
              انتقال وجه
            </Button>
          )}

          {actionsList['reportGuildBtn'] && (
            <Button
              onClick={() =>
                redirectToTransactions(data?.aliasName ?? data.guildSrv?.name, data?.id)
              }
              size="small"
              disabled={!data?.id}
              className={classes.actionButton}
            >
              گزارش صورتحساب
            </Button>
          )}

          {/* Other Actions */}
          <div className={classes.otherActions}>
            {(actionsList['invoiceGuildBtn'] ||
              actionsList['requestsSettlementGuildBtn'] ||
              actionsList['permissionsReceiveGuildBtn'] ||
              actionsList['settlementGuildBtn'] ||
              actionsList['permissionsGrantedGuildBtn']) && (
              <TableItemActionsNew
                iconButton
                startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
                title=""
                otherMenus={[
                  {
                    title: 'گزارش فاکتورها',
                    isShow: !!actionsList['invoiceGuildBtn'],
                    onClick: () => redirectToInvoice(data?.guildSrv?.id),
                  },
                  {
                    title: 'گزارش درخواست‌های تسویه',
                    isShow: !!actionsList['requestsSettlementGuildBtn'],
                    onClick: () => redirectToSettlements(data?.guildSrv?.id),
                  },

                  {
                    title: `${
                      data.isAutoSettle && !hasNoTransaction
                        ? 'غیر فعال‌سازی تسویه خودكار'
                        : 'فعال‌سازی تسویه خودكار'
                    }`,
                    isShow: !!actionsList['settlementGuildBtn'],
                    onClick: () => {
                      if (hasNoTransaction) return;
                      setIsAutoSettleOpen(true);
                    },
                  },

                  {
                    title: 'مجوزهای مالی دریافت شده',
                    isShow: !!actionsList['permissionsReceiveGuildBtn'],
                    onClick: () => redirectToGrantPermision(data?.guildSrv?.code, 'received'),
                  },

                  {
                    title: 'مجوزهای مالی اعطا شده',
                    isShow: !!actionsList['permissionsGrantedGuildBtn'],
                    onClick: () => redirectToGrantPermision(data?.guildSrv?.code, 'awarded'),
                  },
                ]}
              />
            )}
          </div>
        </Grid>
      </CardActions>

      <SimpleDialog
        title={`تسویه خودکار حساب "${
          data.hasOwnProperty('aliasName') ? data.aliasName : data.guildSrv?.name
        }"`}
        open={isAutoSettleOpen}
        style={{ maxWidth: 500 }}
        onClose={() => setIsAutoSettleOpen(false)}
      >
        <AutoSettlementCMP
          guildItem={data}
          onRefreshList={refreshList}
          onEnd={() => {
            setIsAutoSettleOpen(false);
          }}
        />
      </SimpleDialog>
      <ConfirmDialog
        open={openDialog}
        onClose={() => handleCloseDialog(false)}
        onConfirm={handleSubmit}
        title="لطفا نام حساب کسب‌وکار مورد نظر خود را وارد نمایید:"
        confirmButtonText="ثبت"
        cancelButtonProps="انصراف"
        loading={isLoading}
        confirmButtonProps={{ type: 'submit' }}
      >
        <TextField
          name="alias"
          fullWidth
          variant="outlined"
          value={alias}
          onChange={handleChangeInput}
          autoComplete="off"
        />
      </ConfirmDialog>

      <SimpleDialog
        title={`اعطای مجوز مالی "${
          data.hasOwnProperty('aliasName') ? data.aliasName : data.guildSrv?.name
        }"`}
        open={isBusinessGrantPermissionOpen}
        style={{ maxWidth: 500 }}
        onClose={() => setIsBusinessGrantPermissionOpen(false)}
      >
        <BusinessGrantPermission
          onClose={() => setIsBusinessGrantPermissionOpen(false)}
          guildCode={data.guildSrv.code}
        />
      </SimpleDialog>
    </Card>
  );
}

const darkGray = '#263238';
const lightGray = '#3f505a';
const ligherGray = '#cfd8dc';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      boxShadow: 'none',
      border: '1px solid #A1AAE380',
      borderRadius: 10,
      background: '#A1AAE312',
      minHeight: '95px !important',
      padding: theme.spacing(0),
      paddingBottom: theme.spacing(0.5),
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
      '& .MuiCardContent-root': {
        padding: 0,
      },
      '&.disabled': {
        opacity: 0.5,
      },
    },
    currencyText:{
       fontSize: '10px!importtant',
       fontWeight:'bold'
    },
    infoIcon: {
      fontSize: '20px',
      marginBottom: theme.spacing(-0.8),
      marginInlineStart: theme.spacing(1),
      color: theme.palette.grey[800],
      cursor: 'pointer',
    },
    content: {
      position: 'relative',
    },
    // Key Header
    titlePart: {
      marginInlineEnd: 'auto',
      '@media(max-width: 550px)': {
        width: '80%',
      },
    },
    titleText: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'bold',
    },

    subtitleText: {
      fontSize: 13,
      color: '#A4A4A4',
      fontWeight: 'normal',
      marginTop: theme.spacing(0.5),
    },
    actionButtons: {
      marginTop: theme.spacing(0),
      marginInlineStart: theme.spacing(0.6),
    },
    actionButton: {
      color: theme.palette.primary.main,
      paddingInlineStart: `10px`,
      paddingInlineEnd: '10px',
      marginInlineEnd: '6px',
      margin: '2px 0',
      borderRadius: 8,
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
      border: 'solid 1px #e7e7f1',
      backgroundColor: '#ffffff',
      fontSize: '12px',
    },
    balanceTitle: {
      marginTop: theme.spacing(2),
      fontSize: 12,
      color: darkGray,
      fontWeight: 'bold',
    },
    balanceMoney: {
      fontSize: 12,
      color: darkGray,
      fontWeight: 'normal',
      '& span': {
        fontSize: 14,
        color: lightGray,
        marginInlineStart: theme.spacing(0.5),
      },
    },
    titleActions: {
      marginInlineEnd: theme.spacing(0),
      marginTop: theme.spacing(0),
      position: 'absolute',
      right: '16px',
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(0.5),
      padding: 0,
      '& svg': {
        '& path': {
          stroke: '#303d8f',
        },
      },
    },
    propertyContainer: {
      marginTop: theme.spacing(3),
      cursor: 'pointer',
      '&:hover p': {
        color: theme.palette.primary.main,
      },
      '&.disabled': {
        cursor: 'auto',
        '&:hover p': {
          color: 'initial',
        },
      },
    },
    property: {
      fontSize: 14,
      color: lightGray,
      fontWeight: '400',
    },
    propertyIcon: {
      fontSize: 25,
      color: ligherGray,
      marginInlineEnd: theme.spacing(1),
      '&.active': {
        color: '#303D8F',
      },
    },
    otherActions: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(0.7),
      paddingTop: '5px',
      lineHeight: '34px',

      width: 25,
      '@media(max-width: 550px)': {
        fontSize: 12,
        width: '100%',
        margin: '0',
        lineHeight: '40px',
        textAlign: 'right',
        marginRight: '5px',
        marginTop: 10,
      },

      '& .MuiIconButton-root': {
        border: '2px solid #303d8f',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        padding: '0',
        marginRight: 3,
        '& svg': {
          fill: '#303d8f',
          transform: 'scale(0.8)',
        },
      },
      '& .MuiButton-text': {
        fontSize: 13,
        color: '#3a49a3',
        fontWeight: 'bold',
      },
    },
    otherActionsMenu: {
      border: '1px solid #d8d1d1',
      '& .MuiButtonBase-root.Mui-disabled': {
        pointerEvents: 'auto !important',
      },
    },
    otherActionsMenuItem: {
      padding: theme.spacing(1.5),
      color: darkGray,
      minWidth: 160,
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    sheba: {
      marginTop: theme.spacing(1),
    },
    shebaNumber: {
      fontSize: 14,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      overflowWrap: 'break-word',
    },
    copyIcon: {
      fontSize: 15,
    },
    copyIconButton: {
      width: 15,
      height: 15,
      marginInlineStart: theme.spacing(1),
      marginTop: -2,
    },
    cardHeader: {
      padding: theme.spacing(2),
      paddingBottom: '0',
    },
    cardInside: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    expiredFlag: {
      background: ligherGray,
      borderBottomLeftRadius: 10,
      padding: theme.spacing(1, 2),
      paddingBottom: theme.spacing(1.5),
      color: '#455b64',
      fontSize: 13,
      position: 'absolute',
      right: 0,
      top: 0,
      fontWeight: 'bold',
    },
    blockedAmount: {
      color: '#263238',
      fontSize: 12,
      fontWeight: 'bold',
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(2),
    },
    blockedAmountIcon: {
      color: '#263238',
      fontSize: 16,
      fontWeight: 'normal',
      marginBottom: -5,
      marginInlineEnd: theme.spacing(0.5),
    },
  };
});
